export function obfuscateStorageValue(value: string): string {
  // Note: This is lightweight obfuscation (not security/encryption).
  return btoa(value).split('').reverse().join('');
}

export function deobfuscateStorageValue(
  value: string,
): string | undefined {
  if (value === '') return '';
  try {
    return atob(value.split('').reverse().join(''));
  } catch {
    return undefined;
  }
}
